export class ComponentConvertHelper {
    static convertToCanvas(component, internalId, color, text, dimentionsRatio) {
        const convertedComponent = {
            id: component.id,
            internalId: internalId,
            type: component.type,
            color: color,
            text: text,
            width: component.width,
            height: component.height,
            absolutePositionAxisX: component.positionAxisX,
            absolutePositionAxisY: component.positionAxisY,
            positionZ: component.positionAxisZ,
            drawPositionX: 5 + component.positionAxisX * dimentionsRatio,
            drawPositionY: 5 + component.positionAxisY * dimentionsRatio,
            offsetX: 0,
            offsetY: 0,
            dataIdentifier: component.dataIdentifier,
            configuration: component.configuration,
            parameters: component.parameters,
            fonts: undefined === component.fonts ? [] : component.fonts.map(font => Object.assign({}, font)),
            backgrounds: undefined === component.backgrounds ? [] : component.backgrounds.map(background => Object.assign({}, background)),
            margins: undefined === component.margins ? [] : component.margins.map(margin => Object.assign({}, margin)),
            circleElements: undefined === component.circleElements ? [] : component.circleElements.map(circleElement => Object.assign({}, circleElement))
        };

        return convertedComponent;
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/helpers/ComponentConvertHelper.js